import React from 'react';
import { Flex, Typography, theme } from 'antd';

import { PrerenderTokenField } from './PrerenderTokenField';

const { Title, Text } = Typography;

export const INTEGRATION_STEP_TITLE = 'Set up your integration';
export const INTEGRATION_STEP_SUBTITLE = 'Follow the guide or let Nexus AI walk you through it step by step';

export const IntegrationStepHeader = () => {
  const { token } = theme.useToken();

  return (
    <Flex align="flex-end" justify="space-between" gap={token.marginLG}>
      <Flex vertical>
        <Title level={2} style={{ marginBottom: 0 }}>
          {INTEGRATION_STEP_TITLE}
        </Title>
        <Text type="secondary">{INTEGRATION_STEP_SUBTITLE}</Text>
      </Flex>

      <PrerenderTokenField />
    </Flex>
  );
};
